import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModal, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { RouterModule } from '@angular/router';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { Subject } from 'rxjs';
import { UtilityService } from '../../Model/utility/utility.service';
import { ApprovalMatrixService } from '../../Model/ApprovalMatrix/approval-matrix.service';
import { CommonService } from '../../Model/Common/common.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { SessionService } from '../../Util/Session/session.service';
import moment from 'moment';
import { ReimbursementformService } from '../../Model/Reimbursement/reimbursementform.service';
import { AlertSuccessComponent } from '../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';
import { Console } from 'console';
import { ThumbnailAttachmentComponent } from '../../Component/thumbnail-attachment/thumbnail-attachment.component';
import { DownloadSampleService } from '../../Model/DownloadSample/download-sample.service';
import { ApprovalMatrixViewComponent } from '../../approval-matrix-view/approval-matrix-view.component';

@Component({
  selector: 'app-pay-reimbursement',
  standalone: true,
  imports: [DataTablesModule, CommonModule, RouterModule, LoaderComponent, FormsModule, NgbDatepickerModule, ThumbnailAttachmentComponent],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './pay-reimbursement.component.html',
  styleUrl: './pay-reimbursement.component.scss'
})
export class PayReimbursementComponent {
  isDisabled: boolean = false;
  TableDatas = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  // Reimbursed
  user = [] as any;
  Filter = {
    SelectType: '1',
    EmpMasterId: 0,
    ApprovalStatus: 'Reimburse Pending',
    Remark: null,
    ESS_ReimbursementRequestId: null,
    ESS_ReimbursementTypeId: null as any,
    OutstandingAmount: null,
    BillAmount: null,
    ClaimedAmount: null,
    MonthYear: '',
    selectedMonth: null as any,
    selectedYear: '',
    Attachment: '',
    IsCheckedbox: false,
    EmpType: 'front'
  }
  selectedMonth: any = null;
  MainDatas = [];
  dtoptions: DataTables.Settings = {};
  constructor(
    private reimbursement: ReimbursementformService,
    protected common: CommonService,
    private toast: ToastService,
    private session: SessionService,
    private utility: UtilityService,
    private dateFromat: CustomDateParserFormatter,
    private tooltip: TooltipService,
    private modalService: NgbModal,
    private download: DownloadSampleService
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    // this.common.PageRight.IsView = true;
    // this.common.PageRight.IsAdd = true;
    // this.common.PageRight.IsPrint = true;
    // this.common.PageRight.IsEdit = true;
    // this.common.PageRight.IsDelete = true;
    //this.Filter.EmpMasterId = this.user.UserId;
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESS_ReimbursementLoad();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  Validate(form: any) {
    if (form.valid) {
      this.ESS_ReimbursementLoad();
    } else {
      form.submitted = true;
    }
  }

  ESS_ReimbursementLoad() {
    this.Filter.SelectType = '1';
    this.Filter.MonthYear = this.Filter.IsCheckedbox ? this.Filter.MonthYear : '';
    this.isDisabled = true
    this.reimbursement.ESS_ReimbursementRequest_Load(this.Filter).subscribe({
      next: (data) => {
        this.MainDatas = data.Table;
        this.TableDatas = Object.values(this.MainDatas.filter((e: any) => this.common.ToLowerCase(e.EmpType) == this.Filter.EmpType));
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false
      },
      complete: () => {
        this.isDisabled = false
      },
      error: (error) => {
        this.isDisabled = false
        console.error('Error:', error);
      },
    });
  }
  Clear() {
    this.TableDatas = [];
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }
  onNavigate() {
    const startFromDate = new Date(this.selectedMonth.year, this.selectedMonth.month - 1, 1);
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long' };
    this.Filter.MonthYear = startFromDate.toLocaleDateString('en-GB', options);
  }

  Link(Text: string) {
    return this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + 'Reimbursement' + '/' + Text;
  }

  FilterEmpType(type: string) {
    this.Filter.EmpType = type;
    this.TableDatas = Object.values(this.MainDatas.filter((e: any) => this.common.ToLowerCase(e.EmpType) == this.Filter.EmpType));
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }

  ARCheck(event: any, i: number, IsAll = false) {
    if (IsAll) {
      this.TableDatas.map((e: any) => e.IsARCheck = event.target.checked);
    } else {
      this.TableDatas[i].IsARCheck = event.target.checked;
    }
  }


  ESS_ReimbursementRequestUpdate_At() {
    if (this.TableDatas.filter((e: any) => e.IsARCheck).length > 0) {
      // const checkedSiteIds = this.TableDatas.filter((row: { IsARCheck: any; IsReimbursed: boolean; }) => row.IsARCheck && row.IsReimbursed === false).map((row: { ESS_ExpenseReportRequestId: any; }) => row.ESS_ExpenseReportRequestId);
      // const siteIds = checkedSiteIds.join(',');
      // console.log('Selected Site IDs:', siteIds);
      // if (siteIds == '') {
      //   const modalRef = this.modalService.open(AlertWarningComponent, {
      //     size: 'md',
      //     backdrop: 'static',
      //     centered: true,
      //     windowClass: 'confirmation-modal'
      //   });
      //   modalRef.componentInstance.Message = 'This expense request has already been reimbursed.';
      //   modalRef.result.then(() => { });
      //   return;
      // }
      const selectedItems = this.TableDatas.filter((item: { IsARCheck: boolean }) => item.IsARCheck);
      const IDs = selectedItems.map((item: { ESS_ReimbursementRequestId: any }) => item['ESS_ReimbursementRequestId']);
      const Ids = IDs.join(', ');
      const modalRef = this.modalService.open(ConfirmationComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = 'Do you want to Pay?';
      modalRef.result.then((result: any) => {
        if (this.common.PageRight.IsAdd || this.common.PageRight.IsEdit) {
          if (result) {
            this.isDisabled = true;
            this.reimbursement.ESS_ReimbursementRequestUpdate_At({ SelectType: 'R', ESS_ReimbursementRequestId: Ids }).subscribe({
              next: (response) => {
                if (response.Error_Code == '588') {
                  const modalRef = this.modalService.open(AlertSuccessComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = response.Error_Message;
                  modalRef.result.then((result: any) => {
                    this.ESS_ReimbursementLoad();
                  });
                  this.isDisabled = false;
                } else {
                  const modalRef = this.modalService.open(AlertWarningComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = response.Error_Message;
                  modalRef.result.then((result: any) => { });
                  this.isDisabled = false;
                }
              },
              complete: () => { },
              error: (error) => {
                this.isDisabled = false;
              },
            });
          }
        }
        else {
          this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
        }
      }).catch(() => { });
    }
    else {
      this.toast.show({ message: 'Kindly select atleast one checkbox for Payment', type: toastTypeEnum.warning });
    }
  }

  ExcelDump() {
    if (this.TableDatas.length == 0) {
      this.toast.show({ message: 'No Data Found', type: toastTypeEnum.warning });
    } else {
      this.download.exportToExcelWithProgress(this.TableDatas, 'Reimbursement Pay')
    }
  }

  viewApprovalMatrix(i: number) {
      const modalRef = this.modalService.open(ApprovalMatrixViewComponent, { size: 'md', backdrop: 'static' });
      modalRef.componentInstance.TransactionId = this.TableDatas[i]['ESS_ReimbursementRequestId'];
      modalRef.componentInstance.EmployeeId = this.TableDatas[i]['EmpMasterId'];
      modalRef.componentInstance.RequestDate = this.TableDatas[i]['RequestDate'];
      modalRef.componentInstance.ApprovalStatus = this.TableDatas[i]['ApprovalStatus'];
      modalRef.componentInstance.ModuleMasterId = 16;
    }
}
